export default __webpack_public_path__ + "static/media/3.fd9ad96e.jpg";